module.exports = __webpack_public_path__ + "img/parasol.8a5eee13.jpg";